import './Wizard.scss';

export { default } from './Wizard';
